<!--
 * @Author: your name
 * @Date: 2021-08-30 13:53:22
 * @LastEditTime: 2021-09-09 14:33:31
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \dc-hero-bump-website-front\src\components\NewsDetail.vue
-->
<template>
  <section>
    <div class="position">
      <router-link tag="span" to="/">{{ $t("home") }}</router-link> >
      <router-link tag="span" to="/gameNews/newsList" class="sub">
        {{ $t("news_title") }}</router-link>
          &nbsp; &nbsp;
      <span class="gray"> &nbsp; &nbsp;{{ infoContent.create_time }}</span>
    </div>
    <div class="title">{{ infoContent.title }}</div>
    <div class="content" id="herobump-newsDetail">
      <div v-html="infoContent.content"></div>
    </div>
  </section>
</template>
<script>
import { getInformationContent } from '../api/index'
export default {
  name: 'NewDetail',
  data () {
    return {
      langMatch: {
        zhCHT: 'zh-cn',
        zhEn: 'en'
      },
      infoContent: {
        title: '',
        desc: '',
        content: '',
        lang: '',
        create_time: ''
      }
    }
  },
  created () {
    this.getContent()
  },
  methods: {
    async getContent () {
      const param = {
        info_id: Number(this.$route.query.id),
        lang: this.langMatch[this.store.globalData.lang]
      }
      const res = await getInformationContent(param)
      if (res.code === 1) {
        this.infoContent = res.data
      }
    }
  },
  watch: {
    'store.globalData.lang' () {
      this.getContent()
    }
  }
}
</script>
<style lang="less" scoped>
.position {
  text-align: left;
  padding: 6px;
  margin: 6px 0;
  font-weight: bold;
}
.gray{
    color:#c0c8d0;
    font-weight: normal;
}
.sub {
  color: #6c65ea;
}
.title {
  text-align: center;
  font-size: 42px;
  font-weight: bold;
  font-stretch: normal;
  color: #6c65ea;
  margin: 40px 0 30px 0;
}
.content {
  width: 100%;
  padding: 57px 47px;
  text-align: left;
  min-height: 400px;
  border: 2px solid #eee;
}
@media screen and (max-width: 750px) {
  .position {
    text-align: left;
    margin: 0.25rem 0.2rem;
  }
  .title {
    text-align: center;
    font-size: 0.36rem;
    font-weight: bold;
    font-stretch: normal;
    color: #6c65ea;
    margin: 0.7rem 0 0.3rem 0;
  }
  .content {
    width: 100%;
    box-shadow: none;
    // padding: 0.16rem 0.3rem;
    padding: 0.16rem 0.3rem 0.6rem 0.3rem;
    box-sizing: border-box;
    min-height: 10.8rem;
    background: url("../assets/app/bg3.png") top center no-repeat,
      url("../assets/app/bg2.png") bottom center no-repeat;
    background-color: #fff;
    background-size: 100%, 100%;
    border:0
  }
  img {
    width: 6rem;
    height: 5rem;
  }
}
</style>
<style lang='less'>
#herobump-newsDetail{
  &>a, abbr, acronym, address, applet, article, aside, audio, b, big, blockquote, body, canvas, center, cite, code, dd, del, details, dfn, div, dl, dt, em, embed, fieldset, figcaption, figure, footer, form, h1, h2, h3, h4, h5, h6, header, hgroup, html, i, iframe, img, ins, kbd, label, legend, li, main, mark, menu, nav, object, ol, output, p, pre, q, ruby, s, samp, section, small, span, strike, strong, sub, summary, sup, time, tt, u, ul, var, video{
    font-weight: revert;
  }
}
</style>
